"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatingIndex = void 0;
class ValidatingIndex {
    static get(node) {
        return node.statistics.validating30DaysPercentage / 100;
    }
}
exports.ValidatingIndex = ValidatingIndex;
//# sourceMappingURL=validating-index.js.map